require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-optimise-email-marketing-for-shopify-we-speak-to-omnisend-founder-rytis-lauris.json") })
        }
      }, "path---blog-how-to-optimise-email-marketing-for-shopify-we-speak-to-omnisend-founder-rytis-lauris");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-optimise-email-marketing-for-shopify-we-speak-to-omnisend-founder-rytis-lauris!./.cache/json/blog-how-to-optimise-email-marketing-for-shopify-we-speak-to-omnisend-founder-rytis-lauris.json
// module id = 463
// module chunks = 231608221292675